// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"caa0b9a8","777":"e00f1803","930":"c0d007ea","994":"1380df28"}[chunkId] + ".chunk.js";
};